import { useTranslation } from 'react-i18next'

import { getBaggageText } from 'entities/ticket/ui/card-of-ticket/ui/components/indicators/libs/getBaggageText.ts'

import { Baggage } from 'shared/models/ticket'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { BaggageInfo } from '../../../module'

import s from './styles.module.scss'

const BaggageIcons = {
  baggage: {
    active: AllIcons.BAGGAGE,
    disabled: AllIcons.BAGGAGE_DISABLED,
    disabled_text: 'without_baggage_capital',
  },
  cbaggage: {
    active: AllIcons.CBAGGAGE,
    disabled: AllIcons.CBAGGAGE_DISABLED,
    disabled_text: 'without_cbaggage_capital',
  },
}

export type BaggageIcon = keyof typeof BaggageIcons

interface Props {
  baggageInfo?: BaggageInfo
}

interface IndicatorProps {
  baggage?: Baggage
  typeBaggage: BaggageIcon
}

export const IndicatorIconDisabled = ({
  icon,
  text,
}: {
  icon: AllIcons
  text: string
}) => {
  return (
    <div className={s.indicatorIconDisabled}>
      <AppIcon
        id={icon}
        width={16}
        height={16}
        className={s.icon}
      />

      <span className="medium-12">{text}</span>
    </div>
  )
}

const Indicator = ({ baggage, typeBaggage }: IndicatorProps) => {
  const { t } = useTranslation()

  const icons = BaggageIcons[typeBaggage]

  const baggageText = getBaggageText(baggage, typeBaggage)

  if (!baggage) {
    return (
      <IndicatorIconDisabled
        icon={icons?.disabled}
        text={t(icons?.disabled_text)}
      />
    )
  }

  if (baggage?.piece && !baggage?.weight) {
    return (
      <div className={s.indicatorContainer}>
        <AppIcon
          width={16}
          height={16}
          id={icons?.active}
          className={s.icon}
        />

        <span className="medium-12">{t('included')}</span>
      </div>
    )
  }

  if (!baggage?.piece || !baggage?.weight) {
    return (
      <IndicatorIconDisabled
        icon={icons?.disabled}
        text={t(icons?.disabled_text)}
      />
    )
  }

  return (
    <div className={s.indicatorContainer}>
      <AppIcon
        width={16}
        height={16}
        id={icons?.active}
        className={s.icon}
      />

      <span className="medium-12">{baggageText}</span>
    </div>
  )
}

export const Indicators = ({ baggageInfo }: Props) => {
  return (
    <div className={s.container}>
      <div className={s.baggageWrapper}>
        <Indicator
          typeBaggage="baggage"
          baggage={baggageInfo?.baggage}
        />

        <Indicator
          typeBaggage="cbaggage"
          baggage={baggageInfo?.cbaggage}
        />
      </div>
    </div>
  )
}
